import { NgModule } from '@angular/core';
import { MapGetPipe } from "./map-get.pipe";
import { CommonModule } from '@angular/common';
import { MapEntriesPipe } from "./map-entries.pipe";

@NgModule({
    imports: [CommonModule],
    exports: [
        MapGetPipe,
        MapEntriesPipe,
    ],
    declarations: [
        MapGetPipe,
        MapEntriesPipe,
    ],
    providers: [
        MapGetPipe,
        MapEntriesPipe,
    ],
})
export class MapPipeModule {
}
